module.exports = __webpack_public_path__ + "static/media/ab-testing-panel.ec781518.png";